export default [
    '#dcecc9',
    '#b3ddcc',
    '#8acdce',
    '#62bed2',
    '#4885ed',
    '#3d91be',
    '#3577ae',
    '#3577ae',
    '#24448e',
    '#0088CC',
    '#EF7215',
    '#FDA50F',
    '#FFBF00',
    '#D7722C',
    '#F05E23',
    '#CB5C0D',
];


// WEBPACK FOOTER //
// ./src/styles/ChartsColors.js